import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button, IconButton, InputAdornment, Link, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import PhoneNumberFields from './PhoneNumberFields';

function SignupForm({
  busyAction,
  cooldownSecondsLeft,
  form,
  otpRequested,
  onChange,
  onModeChange,
  onRequestOtp,
  onComplete,
  onResendOtp,
}) {
  const cooldownActive = cooldownSecondsLeft > 0;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Stack spacing={2}>
      <PhoneNumberFields form={form} minLocalLength={8} onChange={onChange} />
      <TextField
        fullWidth
        label="Email"
        onChange={(event) => onChange({ ...form, email: event.target.value })}
        type="email"
        value={form.email}
      />

      {otpRequested ? (
        <>
          <TextField
            fullWidth
            label="OTP code"
            onChange={(event) => onChange({ ...form, otpCode: event.target.value })}
            value={form.otpCode}
          />
          <TextField
            fullWidth
            label="Password"
            onChange={(event) => onChange({ ...form, password: event.target.value })}
            type={showPassword ? 'text' : 'password'}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                      edge="end"
                      onClick={() => setShowPassword((current) => !current)}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            value={form.password}
          />
        </>
      ) : null}

      {!otpRequested ? (
        <Button
          disabled={busyAction === 'signup-request-otp' || cooldownActive}
          fullWidth
          onClick={onRequestOtp}
          size="large"
          variant="contained"
        >
          {busyAction === 'signup-request-otp'
            ? 'Sending OTP...'
            : cooldownActive
              ? `Try again in ${cooldownSecondsLeft}s`
              : 'Continue'}
        </Button>
      ) : (
        <Stack spacing={1.5}>
          <Button
            disabled={busyAction === 'signup-complete'}
            fullWidth
            onClick={onComplete}
            size="large"
            variant="contained"
          >
            {busyAction === 'signup-complete' ? 'Creating account...' : 'Create account'}
          </Button>
          <Button
            color="secondary"
            disabled={busyAction === 'signup-request-otp' || cooldownActive}
            onClick={onResendOtp}
            variant="text"
          >
            {cooldownActive ? `Resend code in ${cooldownSecondsLeft}s` : 'Resend code'}
          </Button>
        </Stack>
      )}

      <Typography color="text.secondary" textAlign="center" variant="body2">
        Already have an account?{' '}
        <Link component="button" onClick={() => onModeChange('login')} type="button" underline="hover">
          Sign in
        </Link>
      </Typography>
    </Stack>
  );
}

export default SignupForm;
